import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Authorization from "@/views/Authorization.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/authorize",
        name: "Authorization",
        component: Authorization,
    },
    {
        path: "/",
        name: "Controller",
        component: () =>
            import(
                /* webpackChunkName: "controller" */ "@/views/Controller.vue"
            ),
        meta: { requiresAuth: true },
    },
    {
        path: "*",
        redirect: () => ({
            name:
                store.state.accessToken !== "" ? "Controller" : "Authorization",
        }),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (
        to.meta.requiresAuth &&
        store.state.accessToken !== "" &&
        from.name &&
        from.name !== "Authorization" &&
        from.query.code !== ""
    ) {
        next({ name: "Authorization" });
    } else {
        next();
    }
});

export default router;
